import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DsAuthService } from '@direction/auth';
import { MenuService } from 'src/app/core/services/menu.service';

@Component({
  selector: 'app-not-authorized',
  styleUrls: ['./not-authorized.component.scss'],
  templateUrl: './not-authorized.component.html'
})
export class NotAuthorizedComponent implements OnInit {
  customerId: string;

  constructor(private router: Router, private authService: DsAuthService, private menuService: MenuService) {}

  ngOnInit(): void {
    this.menuService.setApplicationTitle('Não autorizado');
  }
  goToLogin() {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/auth']);
    });
  }
}
